module.exports = __webpack_public_path__ + "img/set-name.5410c6b6.jpg";